import { ISelectBox } from 'src/api/types/base-types';
import { PARENT_COMPANY_FINANCIAL_COMPANY_SOURCE } from '../enums/parent-company-financial-company-source';

export const parentCompanyFinancialCompanySource: ISelectBox[] = [
    { label: 'Select from Existing companies', value: PARENT_COMPANY_FINANCIAL_COMPANY_SOURCE.SELECT_FROM_EXISTING_COMPANIES },
    { label: 'Write the company name', value: PARENT_COMPANY_FINANCIAL_COMPANY_SOURCE.WRITE_THE_COMPANY_NAME },
];
